import React from 'react';
import { Star, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Lo que más me ayudó fue tener frases y pasos concretos. Antes reaccionaba desde el cansancio. Ahora por lo menos sé por dónde empezar.',
  author: 'Carolina M.',
  role: 'mamá de un nene de 7 años'
}, {
  quote: 'La rutina de mañana y noche sola ya valía la compra. Bajó muchísimo la pelea para salir y dormir.',
  author: 'Luciana F.',
  role: 'mamá con hijo diagnosticado con TDAH'
}, {
  quote: 'El tablero semanal me ordenó la cabeza a mí primero. Y eso hizo que en casa todo se sienta menos caótico.',
  author: 'Marina R.',
  role: 'mamá y docente'
}];
export function Testimonials() {
  return <section className="py-20 bg-white" data-id="element-205">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <div className="text-center mb-16" data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-208">
            Lo que dicen otras madres
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-209">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-ocean-cream p-8 rounded-3xl border border-gray-100 flex flex-col" data-id="element-210">
              <div className="flex items-center gap-1 text-ocean-gold mb-6" data-id="element-211">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-212" />)}
              </div>

              <blockquote className="text-gray-700 text-lg leading-relaxed mb-8 flex-1" data-id="element-213">
                "{t.quote}"
              </blockquote>

              <div className="mt-auto" data-id="element-214">
                <div className="font-bold text-gray-900" data-id="element-215">{t.author}</div>
                <div className="text-gray-500 text-sm mb-2" data-id="element-216">{t.role}</div>
                <div className="flex items-center gap-1 text-xs text-ocean-teal font-medium" data-id="element-217">
                  <CheckCircle2 className="w-3.5 h-3.5" data-id="element-218" />
                  Compra verificada
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}